import { ReactNode } from 'react';

const ClearFalseArgs = (): ReactNode => <>clear: Too many arguments</>;

export default ClearFalseArgs;
